import React from 'react';
import { motion } from 'framer-motion';
import { HeroSection } from '../components/HeroSection';
import { VenueCards } from '../components/VenueCards';
import { AdvantageGrid } from '../components/AdvantageGrid';
import { FloorPlanPreview } from '../components/FloorPlanPreview';
import { QuickQuoteForm } from '../components/QuickQuoteForm';
import { Footer } from '../components/Footer';
export function HomePage() {
  return <motion.main initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen w-full bg-h2o-950 text-slate-100 flex flex-col" data-id="element-423">
      <HeroSection data-id="element-424" />
      <VenueCards data-id="element-425" />
      <AdvantageGrid data-id="element-426" />
      <FloorPlanPreview data-id="element-427" />
      <QuickQuoteForm data-id="element-428" />
      <Footer data-id="element-429" />
    </motion.main>;
}